import { render, staticRenderFns } from "./backToTop.vue?vue&type=template&id=0961d8ca&scoped=true"
import script from "./backToTop.vue?vue&type=script&lang=js"
export * from "./backToTop.vue?vue&type=script&lang=js"
import style0 from "./backToTop.vue?vue&type=style&index=0&id=0961d8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0961d8ca",
  null
  
)

export default component.exports